/**
 * @Description: store状态管理context
 * @Date: 2021-12-21
 * @LastEditTime: 2022-01-06
 */
import React from 'react'
import store from '@/store'

const storeContext = React.createContext(store)

export default storeContext
